module.exports = __webpack_public_path__ + "img/51626515_L.e1a39fbb.png";